import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { PurchaseRequestStatus } from '../enums';

/** Preferências de tela do quadro de solicitações, guardadas no navegador. */
export interface KanbanPreferences {
  /** Colunas (por status) que o usuário recolheu. */
  collapsedStatuses?: PurchaseRequestStatus[];
}

/**
 * Persiste em `localStorage` o que é só conveniência de tela do kanban.
 * O app é SSR: no servidor não há `localStorage`, e leitura/escrita são best-effort.
 */
@Injectable({ providedIn: 'root' })
export class KanbanPreferencesService {
  private static readonly KEY = 'ebarn_kanban_prefs';
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  get(): KanbanPreferences {
    if (!this.isBrowser) return {};
    try {
      const raw = localStorage.getItem(KanbanPreferencesService.KEY);
      return raw ? (JSON.parse(raw) as KanbanPreferences) : {};
    } catch {
      return {};
    }
  }

  patch(partial: KanbanPreferences): void {
    if (!this.isBrowser) return;
    try {
      const next = { ...this.get(), ...partial };
      localStorage.setItem(KanbanPreferencesService.KEY, JSON.stringify(next));
    } catch {
      /* armazenamento indisponível (modo privado, cota cheia): segue sem persistir */
    }
  }
}
